import { analytics } from '../config/firebase';
import { logEvent as firebaseLogEvent } from 'firebase/analytics';

export const logPageView = (path: string) => {
  if (analytics) {
    firebaseLogEvent(analytics, 'page_view', {
      page_path: path,
      page_title: document.title,
    });
  }
};

export const logEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (analytics) {
    firebaseLogEvent(analytics, eventName, eventParams);
  }
};
